const NAV = {
    COLUMN_URL: "/centerNav",//获取導航欄主類目數據
    DATA: "nav",//導航欄數據
    COLUMN_URL_V5: "/centerNav1",//V5获取導航欄主類目數據
    DATA_V5: "nav1",//V5導航欄數據
}
export default NAV